export default __webpack_public_path__ + "static/media/delete-icon-new1.53b6bb31.svg";